export const getTitle = (prefix) => `${prefix} | FINN reise`;
